import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	saveOrResetViewSettingsButton: {
		id: 'issue-navigator-save-reset-view-settings-button.save-or-reset-view-settings-button',
		defaultMessage: 'Save or reset view settings',
		description:
			'Label for the menu trigger button to allow users to save or reset changes made to the view settings',
	},
});
